import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden bg-[#faf8f5]" data-id="element-89">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#1a4d3e]/5 -skew-x-12 transform origin-top-right z-0" data-id="element-90" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#c9a227]/10 rounded-full blur-3xl z-0" data-id="element-91" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-92">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-93">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-94">
            <span className="inline-block px-4 py-1 mb-6 text-sm font-semibold tracking-wider text-[#1a4d3e] uppercase bg-[#1a4d3e]/10 rounded-full" data-id="element-95">
              Para mujeres de 40 a 60 años
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-[#1a4d3e] mb-6 font-serif" data-id="element-96">
              ¿Sientes que tu cuerpo ha declarado una{' '}
              <span className="text-[#c9a227] italic" data-id="element-97">guerra</span> contra ti?
            </h1>

            <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-98">
              Te miras al espejo y no reconoces a esa mujer. Has intentado la
              dieta keto, el ayuno extremo, has pasado hambre... y sin embargo,
              esa "llantita" abdominal parece haberse mudado permanentemente a
              tu cintura.
            </p>

            <div className="flex flex-col gap-4" data-id="element-99">
              <CountdownTimer hours={1} minutes={47} seconds={33} data-id="element-100" />
              <div className="flex flex-col sm:flex-row gap-4 items-start" data-id="element-101">
                <Button size="lg" withArrow bounce href="https://ecoterr4.com/cart/44441705480271:1" data-id="element-102">
                  ¡QUIERO MI METABO-RESET AHORA!
                </Button>
                <p className="text-sm text-gray-500 mt-2 sm:mt-0 sm:ml-4 flex items-center italic" data-id="element-103">
                  *Resultados visibles en 21 días
                </p>
              </div>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-104">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/3cqEAQsSuqJfobsrDXMsvu/IMAGEN_2B.jpg" alt="Transformación con Protocolo Metabo-Reset 40+" className="w-full h-auto object-cover" data-id="element-106" />

              {/* Floating Badge */}
              <motion.div initial={{
              y: 20,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} transition={{
              delay: 1,
              duration: 0.5
            }} className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm p-4 rounded-lg shadow-lg max-w-xs border-l-4 border-[#c9a227]" data-id="element-107">
                <p className="text-[#1a4d3e] font-serif font-bold text-lg" data-id="element-108">
                  "No es tu culpa"
                </p>
                <p className="text-sm text-gray-600" data-id="element-109">
                  Es tu interruptor hormonal.
                </p>
              </motion.div>
            </div>

            {/* Decorative circle behind image */}
            <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] border border-[#1a4d3e]/20 rounded-full" data-id="element-110" />
            <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] border border-[#c9a227]/30 rounded-full" data-id="element-111" />
          </motion.div>
        </div>
      </div>
    </section>;
}